import React, { useCallback, useEffect, useState } from 'react'
import * as actions from '../../actions'
import { connect } from 'react-redux'
import { reduxForm, isInvalid, isSubmitting, formValueSelector } from 'redux-form'
import { FORM_PESO_BRUTO } from '../../../../config/forms'
import { Card, Row, Col } from 'react-bootstrap'
import BalanzaInfo from '../../components/BalanzaInfo'
import { INTERVALO_EXTRA_CORTO, INTERVALO_LARGO } from '../../../../config/settings'
import DialogoAlertaPeso from '../../components/pesado/DialogoAlertaPeso'
import ConfiguracionPesadoBruto from '../../components/pesado/ConfiguracionPesadoBruto'
import { toast, ToastContainer } from 'react-toastify'
import DialogoErrorPesado from '../../components/pesado/DialogoErrorPesado'
import ReporteProductos from './ReporteProductos'
import TipoDePesado from '../../components/pesado/TipoDePesado'
import UltimoPesadoInfo from '../../components/UltimoPesadoInfo'
import PesadoConRemito from '../pesadoConRemito/PesadoConRemito'
import PesadoBrutoBalanceroManual from './PesadoBrutoBalanceroManual'
import PesadoBrutoBalanceroAuto from './PesadoBrutoBalanceroAuto'
import CerealAsignadoAVolcadora from '../../components/bruto/CerealAsignadoAVolcadora'
import InfoIcon from '@material-ui/icons/Info'
import moment from 'moment'
import ControlBarrerasBruto from '../../components/pesado/ControlBarrerasBruto'
import EdicionAutodescargable from '../../../Camiones/components/EdicionAutodescargable'
import { COLORES } from '../../../../config/colores'

function PesadoBrutoBalancero (props) {
  const {
    change: formChange,
    cea,
    cpe,
    numero,
    pesoMinimo,
    pesaje,
    balanza,
    pesoMaximo,
    pesoCabezal,
    callesDeCalado,
    ultimoPesado,
    camListosParaBruto,
    cpaEntrePlayaCalado,
    pesoBruto,
    pedirConfirmacion
  } = props

  const [pesadoEnCabina, setPesadoCabina] = useState(false)
  const [textoPesado, setTextoPesado] = useState('Pesado bruto')
  const [showAlertaPeso, setShowAlertaPeso] = useState(false)
  const [tipoAlertaPeso, setTipoAlertaPeso] = useState('')
  const [confirmacionAlerta, setConfirmacionAlerta] = useState(false)
  const [showRelectura, setShowRelectura] = useState(false)
  const [pesadoOk, setPesadoOk] = useState(false)
  const [init, setInit] = useState(false)
  const [timer, setTimer] = useState(0)
  const [tipoPesado, setTipoPesado] = useState('circuito')
  const [dialog, setDialog] = useState(false)
  const [calculoDemora, setCalculoDemora] = useState(false)
  const [errorBarreras, setErrorBarreras] = useState(false)

  const alertaPesoAdvertencia = useCallback(() => {
    setShowAlertaPeso(true)
    setTipoAlertaPeso('advertencia')
    formChange('alertaPeso', true)
  }, [formChange])

  const alertaPesoMaximo = useCallback(() => {
    setShowAlertaPeso(true)
    setTipoAlertaPeso('maximo')
    formChange('alertaPeso', true)
  }, [formChange])

  const clearForm = useCallback(() => {
    const { change: formChange } = props
    formChange('numero', '')
    formChange('pesoBruto', '')
    formChange('calle', '')
  }, [props])

  const updateRepeso = useCallback(() => {
    const { repesoBruto, change: formChange } = props
    if (repesoBruto === 1) {
      setTextoPesado('Pesado bruto')
      props.updateParametroInteger('REPESOBR', 0)
      formChange('repesoBruto', false)
    } else {
      setTextoPesado('Repeso bruto')
      props.updateParametroInteger('REPESOBR', 1)
      formChange('repesoBruto', true)
      // if (cpe) {
      //   deleteCpe(cpe.numero)
      //   props.resetConsultaCeaBruto()
      // }
    }
    // clearForm()
    props.queryParametrosBruto()
  }, [props])

  const resetParam = useCallback(() => {
    const { repesoBruto } = props
    setShowRelectura(false)
    setPesadoOk(false)
    setConfirmacionAlerta(false)
    setCalculoDemora(false)
    props.resetDemoraDesdeEgreso()
    setTipoAlertaPeso('')

    if (repesoBruto === 1) {
      updateRepeso()
    }
    clearForm()
  }, [props, clearForm, updateRepeso])

  const deleteCpe = useCallback((numero) => {
    props.deleteCpeEnBruto(numero)
    props.resetConsultaCeaBruto()
    resetParam()
  }, [props, resetParam])

  useEffect(() => {
    const { pesoMinimoDiferencia, cpe } = props

    async function setUp () {
      formChange('numero', '')
      formChange('pesoBruto', '')
      formChange('repesoBruto', false)
      props.updateParametroInteger('REPESOBR', 0)
      setTextoPesado('Pesado bruto')
      setTipoPesado('circuito')
      setCalculoDemora(false)
      const parametros = await props.queryParametrosBruto()
      console.log(parametros)

      const peso = await props.requestPesoBruto()
      props.getCpeEnBruto()

      if (parseInt(peso) < parseInt(pesoMinimoDiferencia)) {
        if (cpe) {
          props.resetConsultaCeaBruto()
          deleteCpe(cpe.numero)
        }
      }
    }

    const intervalParametros = setInterval(async () => {
      props.getModoPesajeBruto()
      props.getRepesoBruto()
      props.getEquilibrioBruto()
    }, [INTERVALO_LARGO])

    const intervalCpeBruto = setInterval(async () => {
      const { change: formChange, pesoBruto, numero, cea, pesoMaximoAdvertencia, demoraDesdeEgreso } = props

      if (timer > 0) {
        setTimer(timer - 1)
        console.log('timer , ', timer)
      }

      if (tipoPesado === 'circuito') {
        if (ultimoPesado && cpe && cpe.numero && (ultimoPesado.cartaDePorteAutomotor === cpe.numero) && !pesadoOk) {
          setPesadoOk(true)
          setShowRelectura(false)
        }

        if (!cpe && timer === 0 && pesaje === 'auto') {
          if (numero) {
            clearForm()
          }
          if (cea && cea.cartaDePorteAutomotor) {
            props.resetConsultaCeaBruto()
          }
          if (textoPesado === 'Repeso tara') {
            setTextoPesado('Pesado tara')
            props.updateEnclavamientoBruto(1)
            props.updateParametroInteger('REPESOBR', 0)
          }
          if (showAlertaPeso) { setShowAlertaPeso(false) }
          if (showRelectura) { setShowRelectura(false) }
          if (pesadoOk) { setPesadoOk(false) }
        }

        if (cea && cea.fechaDeEgresoCalado && !calculoDemora) {
          props.calcularDemora(cea.fechaDeEgresoCalado)
          setCalculoDemora(true)
        }

        if (cpe && !confirmacionAlerta) {
          if ((pesoBruto > pesoMaximo) && !cpe.error && !showAlertaPeso) {
            alertaPesoMaximo()
          } else if (demoraDesdeEgreso && !cpe.error && !showAlertaPeso) {
            alertaDemoraCircuito()
          } else if ((pesoBruto > pesoMaximoAdvertencia) && !cpe.error && !showAlertaPeso) {
            alertaPesoAdvertencia()
          }
        }

        if (cpe && cpe.error && !errorBarreras) {
          if (cpe.errorDescripcion === 'Verifique el estado de las barreras') {
            console.log('Verifique el estado de las barreras')
            toast.error('Verifique el estado de las barreras')
            setErrorBarreras(true)
          }
        }

        if (!cpe && showAlertaPeso) {
          setShowAlertaPeso(false)
          clearForm()
        }

        // Pesado modo automatico
        // Recibe el peso que se guardo en CPE. Sino se carga todo manualmente

        if (pesaje === 'auto') {
          if (pesadoEnCabina || (cpe && cpe)) {
            const pesoDesdeCabezal = await props.requestPesoBruto()
            formChange('pesoCabezal', pesoDesdeCabezal && pesoDesdeCabezal)

            // cuando el peso es menor al minimo de dif.: no hay camion en la balanza
            if ((parseInt(pesoDesdeCabezal) < parseInt(pesoMinimoDiferencia)) && cpe) {
              deleteCpe(cpe.numero)
              props.resetConsultaCeaBruto()
              formChange('pesoBruto', '')
              if (textoPesado === 'Repeso bruto') {
                setTextoPesado('Pesado bruto')
                props.updateEnclavamientoBruto(1)
                props.updateParametroInteger('REPESOBR', 0)
              }
            }
          }
        }

        props.getCpeEnBruto()

        if (cpe && cpe.numero && !cea.cartaDePorteAutomotor && !cpe.error) {
          if ((!numero) || (pesaje === 'manual')) {
            props.requestDatosConsultaCea(cpe.numero)
            if (cpe.pesoBruto) {
              formChange('pesoBruto', (cpe && cpe.pesoBruto))
            }
            formChange('numero', cpe && cpe.numero)

            if (!pesadoOk) { setShowRelectura(true) }
          }
        }

        if (pesaje === 'manual') {
          if (cpe && !numero) {
            formChange('numero', cpe.numero)
          }
          if (cpe && cpe.pesoBruto && !pesoBruto) {
            formChange('pesoBruto', cpe.pesoBruto)
          }
        }
      }
    }, INTERVALO_EXTRA_CORTO)

    if (!init) {
      setUp()
      setInit(true)
    }

    return () => {
      clearInterval(intervalCpeBruto)
      clearInterval(intervalParametros)
    }
  }, [
    props,
    tipoPesado,
    confirmacionAlerta,
    showAlertaPeso,
    timer,
    calculoDemora,
    errorBarreras,
    pesadoEnCabina,
    alertaPesoAdvertencia,
    alertaPesoMaximo,
    init,
    pesadoOk,
    clearForm,
    deleteCpe,
    cpe,
    formChange,
    pesaje,
    pesoMaximo,
    showRelectura,
    textoPesado,
    ultimoPesado
  ]
  )

  const cambiarTipoPesado = (tipo) => {
    setTipoPesado(tipo)
    if (cpe) {
      props.resetConsultaCeaBruto()
      deleteCpe(cpe.numero)
    }
  }

  const clearFormRechazo = () => {
    const { change: formChange } = props
    formChange('numero', '')
    formChange('numeroRechazo', '')
    formChange('motivoRechazo', '')
  }

  const actualizarCalleVolcadora = () => {
    const { numero, calleVolcadora } = props
    if (numero) {
      props.actualizarCalleDeVolcadora(numero, calleVolcadora)
    }
  }

  const submitPesoBruto = () => {
    const { numero, pesoBruto, pesoMinimo, repesoBruto } = props
    if (numero) {
      if (pesoBruto > pesoMinimo) {
        if (cea && cea.cartaDePorteAutomotor) {
          if (repesoBruto === 1) {
            props.submitRepesoBruto()
            updateRepeso()
          } else {
            props.submitPesadoBruto()
          }
          toast.info('Procesando datos')
        } else {
          toast.error('La carta de porte no tiene proceso de calado', { autoClose: false })
          deleteCpe(numero)
          clearForm()
        }
      } else {
        toast.error('', { autoClose: false })
        deleteCpe(numero)
        clearForm()
      }
    } else {
      toast.error('Número inválido', { autoClose: false })
      clearForm()
    }
  }

  const rechazarPesoBruto = (motivo = null) => {
    const { numero } = props
    console.log('numero ', numero)
    if (motivo) { formChange('motivoRechazo', motivo) }
    toast.info('Procesando rechazo')
    props.rechazarCea()
  }

  const alertaDemoraCircuito = () => {
    // setShowAlertaPeso(true)
    setTipoAlertaPeso('demora')
    // formChange('alertaPeso', true)
  }

  const altaPesado = (e = null) => {
    const { numero, pesoMinimo, pesoBruto, change: formChange } = props
    if (e) e.preventDefault()
    if (!isNaN(numero)) {
      if (pesaje === 'auto') {
        if ((String(numero).length === 11) && !isNaN(pesoCabezal) && (pesoCabezal > pesoMinimo)) {
          toast.info('Procesando datos')
          props.admitibleEnBruto(numero, pesoCabezal)
          formChange('pesoBruto', pesoCabezal)
          setShowRelectura(true)
          setTimer(1)
        } else {
          if (String(numero).length !== 11) {
            toast.error('Número invalido')
          } else if (isNaN(pesoCabezal)) {
            toast.error('No llega correctamente el peso de la balanza')
          } else if (pesoCabezal <= pesoMinimo) {
            console.log('El peso es menor al mínimo')
            toast.error('El peso es menor al mínimo')
          }
          formChange('numero', '')
        }
      } else {
        toast.info('Procesando datos')
        if (cpe && cpe.numero === numero) {
          // cuando el numero se cargo desde el totem, solo hay que actualizar el peso
          props.updateCpeEnBruto(numero, pesoBruto)
        } else {
          props.admitibleEnBruto(numero, pesoBruto)
        }
        setShowRelectura(true)
        // }
      }
      setConfirmacionAlerta(false)
    } else {
      toast.error('Número inválido')
      formChange('numero', '')
    }
  }

  const pesarEnCabina = () => {
    setPesadoCabina(!pesadoEnCabina)
    clearForm()
  }

  const closeAlertaPeso = () => {
    setShowAlertaPeso(false)
    if (tipoAlertaPeso === 'maximo') {
      deleteCpe(numero)
    } else {
      setConfirmacionAlerta(true)
    }
    setTipoAlertaPeso('')
  }

  const dialogOpen = (value) => {
    setDialog(value)
  }

  const onBlurInput = () => {
    if (!cpe && !showAlertaPeso && !dialog) {
      if (document.getElementById('numero')) {
        document.getElementsByName('numero')[0].focus()
      }
    }
  }

  const showToast = (error, numero) => {
    toast.error(<div>CTG: {numero}<br /> {error}</div>, { autoClose: INTERVALO_LARGO })
  }

  const setHabilitacionVolcadora = (calle, habilitado) => {
    props.updateHabilitacionVolcadoras(calle, habilitado)
  }

  const setMotivoActividadBarrera = (motivo) => {
    const { change: formChange } = props
    formChange('motivoActBarrera', motivo)
  }

  const updateForzarBarreras = () => {
    const { forzarBarreras } = props
    if (forzarBarreras === 'si') {
      props.anularForzarBarreraBruto()
    } else {
      props.forzarBarreraBruto()
    }
  }

  const updateCicloBarreras = () => {
    const { modoBarreras } = props
    if (modoBarreras === 'auto') {
      props.desactivarBarreraAutomaticoBruto()
    } else {
      props.activarBarreraAutomaticoBruto()
    }
  }

  const updateEnclavamientoBarreras = () => {
    const { enclavamientoBarreras } = props
    if (enclavamientoBarreras === 1) {
      props.actualizarEnclavamientoBarrerasBruto(0)
    } else {
      props.actualizarEnclavamientoBarrerasBruto(1)
    }
    toast.info('El balancero deberá actualizar la interfaz para aplicar los cambios.')
  }

  const actualizarAutodescargable = () => {
    props.resetConsultaCeaBruto()
    props.requestDatosConsultaCea(cpe.numero)
  }

  const bza = {
    balanza,
    pesaje,
    enclavamiento: (props.equilibrio) ? 'Si' : 'No',
    pesoMinimo,
    pesoMaximo
  }

  const pesadoAuto = (pesaje === 'auto')
  const fechaEgresoCalado = moment(cea.fechaDeEgresoCalado).format('DD-MM-YYYY HH:mm')

  const rol = props.roles.filter(roles => roles === 'SUPERVISOR' || roles === 'SUPMANTENIMIENTO' || roles === 'DESARROLLADOR')
  const rolAutorizado = (rol[0] === 'SUPERVISOR' || rol[0] === 'SUPMANTENIMIENTO' || rol[0] === 'DESARROLLADOR')

  return (
    <>
      <ToastContainer />

      {cpe && !errorBarreras && <DialogoErrorPesado
        cpe={cpe}
        borrarCpe={deleteCpe}
        onBlurInput={onBlurInput}
        showToast={showToast}
      />
      }

      <DialogoAlertaPeso
        closeAlerta={closeAlertaPeso}
        rechazarPesoBruto={rechazarPesoBruto}
        show={showAlertaPeso}
        alerta={tipoAlertaPeso}
        numero={numero}
        cea={cea}
      />

      <div className='containter-header-bruto'>
        <div className='conf-balanza'>
          <h4>Configuración de la Balanza</h4>
          <BalanzaInfo balanza={bza} />
        </div>

        <ControlBarrerasBruto
          dialogOpen={dialogOpen}
          setMotivoActividadBarrera={setMotivoActividadBarrera}
          forzarBarreras={props.forzarBarreras}
          modoBarreras={props.modoBarreras}
          updateForzado={updateForzarBarreras}
          updateCicloBarreras={updateCicloBarreras}
          rolAutorizado={rolAutorizado}
          abrirBarreraEntradaBruto={props.abrirBarreraEntradaBruto}
          cerrarBarreraEntradaBruto={props.cerrarBarreraEntradaBruto}
          cerrarBarreraSalidaBruto={props.cerrarBarreraSalidaBruto}
        />

        <div className='opciones-tipo-pesado'>
          <TipoDePesado setTipoPesado={cambiarTipoPesado} tipoPesado={tipoPesado} />
        </div>
      </div>

      <br />

      <div className='cabecera-bruto-balancero'>
        <Card className='card-pesado-bruto'>
          <Row style={{ alignItems: 'center' }}>
            <Col md={9}>
              {tipoAlertaPeso === 'demora' && tipoPesado === 'circuito'
                ? <div className='msj-info-alerta msj-demora'>
                  <InfoIcon style={{ color: '#ffffff', margin: '0 8px 0 0' }} />
                      Atención: la carga superó el tiempo limite de demora entre el egreso de la playa de calado y la balanza de bruto.
                      Egreso: {fechaEgresoCalado}
                </div>
                : <></>
              }

            </Col>

            <Col md={3}>
              {cea && cea.camion &&
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-end',
                    backgroundColor: cea.autodescargable ? '#605c97' : COLORES.grey.light,
                    color: cea.autodescargable ? 'white' : COLORES.grey.dark,
                    borderRadius: '8px'
                  }}
                >
                  <h6>Autodescargable: </h6> <EdicionAutodescargable cea={cea} actualizarData={actualizarAutodescargable} colorAutodescargable={'white'} />
                </div>
              }
            </Col>
          </Row>

          { tipoPesado === 'circuito'
            ? <div className='container-cabecera-pesado container-cabecera-pesado-bruto'>

              { pesadoAuto
                ? <>
                  {/* ------> Modo automatico  <------ */}
                  <PesadoBrutoBalanceroAuto
                    cpe={cpe}
                    cea={cea}
                    altaPesado={altaPesado}
                    pesoCabezal={pesoCabezal}
                    pedirConfirmacion={pedirConfirmacion}
                    submitPesoBruto={submitPesoBruto}
                    actualizarCalleVolcadora={actualizarCalleVolcadora}
                    rechazarPesoBruto={rechazarPesoBruto}
                    clearFormRechazo={clearFormRechazo}
                    dialogOpen={dialogOpen}
                    showRelectura={showRelectura}
                    deleteCpe={deleteCpe}
                    pesadoAuto={pesadoAuto}
                    pesadoEnCabina={pesadoEnCabina}
                    pesadoOk={pesadoOk}
                  />
                </>
                : <>
                  {/*  ------> Modo manual  <------ */}
                  <PesadoBrutoBalanceroManual
                    cpe={cpe}
                    cea={cea}
                    pesadoAuto={pesadoAuto}
                    pesoBruto={pesoBruto}
                    altaPesado={altaPesado}
                    onBlurInput={onBlurInput}
                    submitPesoBruto={submitPesoBruto}
                    rechazarPesoBruto={rechazarPesoBruto}
                    actualizarCalleVolcadora={actualizarCalleVolcadora}
                    deleteCpe={deleteCpe}
                    showRelectura={showRelectura}
                    dialogOpen={dialogOpen}
                    pedirConfirmacion={pedirConfirmacion}
                    confirmacionAlerta={confirmacionAlerta}
                  />
                </>
              }

              <br />
            </div>
            : <></>
          }

          { (tipoPesado === 'Pesado subproducto')
            ? <PesadoConRemito
              pesaje={pesaje}
              tipoPesado={tipoPesado}
            />
            : <></>
          }

        </Card>
        {props.volcadorasConCereal && <div
          className='container-cereales-en-volcadoras'
        >
          <CerealAsignadoAVolcadora
            volcadorasConCereal={props.volcadorasConCereal}
            calleDeVolcadora={props.calleDeVolcadora}
            setHabilitacion={setHabilitacionVolcadora}
          />
        </div>
        }
      </div>

      <div className='container-config-pesado'>

        <div className='container-config-balancero'>
          {ultimoPesado ? <UltimoPesadoInfo ultimoPesado={ultimoPesado} /> : <></> }
          <ConfiguracionPesadoBruto
            balanza={balanza}
            pesadoEnCabina={pesarEnCabina}
            updateRepeso={updateRepeso}
            pesadoAuto={pesadoAuto}
            tipoPesado={tipoPesado}
            dialogOpen={dialogOpen}
            setMotivoActividadBarrera={setMotivoActividadBarrera}
            updateEnclavamientoBarreras={updateEnclavamientoBarreras}
            enclavamientoBarreras={props.enclavamientoBarreras}
          />
        </div>

        <div className='container-info-para-balancero'>
          <div className='container-card-info-bruto'>
            <ReporteProductos
              cpaEntrePlayaCalado={cpaEntrePlayaCalado}
              callesDeCalado={callesDeCalado}
              camListosParaBruto={camListosParaBruto}
              receiveCpaEntrePlayaCalado={props.receiveCpaEntrePlayaCalado}
              receiveCallesDeCalado={props.receiveCallesDeCalado}
              receiveCamListosParaBruto={props.receiveCamListosParaBruto}
              calificacionCalles={props.calificacionCalles}
              camionesCalados={props.camionesCalados}
              ocupacionCalles={props.ocupacionCallesCalado}
              dialogOpen={dialogOpen}
              cortesPedidos={props.cortesPedidos}
              receiveCamEntreBrutoDestare={props.receiveCamEntreBrutoDestare}
              camEntreBrutoDestare={props.camEntreBrutoDestare}
            />
          </div>

        </div>

      </div>

    </>
  )
}

const selector = formValueSelector(FORM_PESO_BRUTO)

const mapStateToProps = (state) => ({
  alertaPeso: selector(state, 'alertaPeso') || false,
  balanza: state.pesado.balanzaBruto,
  calificacionCalles: state.calado.calificacionPorCalleCalado,
  calleDeVolcadora: state.volcadora.calleDeVolcadora,
  callesDeCalado: state.calado.callesCaladoPorCerealHum,
  calleVolcadora: selector(state, 'calleVolcadora'),
  camEntreBrutoDestare: state.camionesIngreso.camEntreBrutoDestare,
  camionesCalados: state.pesado.camionesCalados,
  camListosParaBruto: state.camionesIngreso.camListosParaBruto,
  cea: state.pesado.consultaCeaBruto || {},
  cortesPedidos: state.camionesIngreso.cortesPedidos,
  cpaEntrePlayaCalado: state.camionesIngreso.cpaEntrePlayaCalado,
  cpe: state.pesado.cpePesadoBruto,
  demoraDesdeEgreso: state.pesado.demoraDesdeEgreso,
  equilibrio: state.pesado.equilibrioBruto,
  enclavamientoBarreras: state.pesado.enclavamientoBarrerasBruto,
  forzarBarreras: state.pesado.forzarBarrerasBruto,
  invalid: isInvalid(FORM_PESO_BRUTO)(state),
  modoBarreras: state.pesado.modoBarrerasBruto,
  numero: selector(state, 'numero'),
  ocupacionCallesCalado: state.calado.estadoOcupacionCallesCalado,
  pedirConfirmacion: state.pesado.pedirConfirmacion,
  pesaje: state.pesado.pesajeBruto,
  pesoBruto: selector(state, 'pesoBruto'),
  pesoCabezal: selector(state, 'pesoCabezal'),
  pesoMaximo: state.pesado.pesoMaximo,
  pesoMaximoAdvertencia: state.pesado.pesoMaximoAdvertencia,
  pesoMinimo: state.pesado.pesoMinimo,
  receiveCallesDeCalado: state.calado.receiveCallesCaladoPorCerealHum,
  receiveCamEntreBrutoDestare: state.camionesIngreso.receiveCamEntreBrutoDestare,
  receiveCamListosParaBruto: state.camionesIngreso.receiveCamListosParaBruto,
  receiveCpaEntrePlayaCalado: state.camionesIngreso.receiveCpaEntrePlayaCalado,
  repeso: selector(state, 'repesoBruto'),
  repesoBruto: state.pesado.repesoBruto,
  roles: state.auth.roles,
  submitting: isSubmitting(FORM_PESO_BRUTO)(state),
  ultimoPesado: state.pesado.ultimoPesadoBruto,
  volcadorasConCereal: state.volcadora.volcadorasConCereal
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PESO_BRUTO,
  destroyOnUnmount: false,
  initialValues: {
    calleVolcadora: '',
    pesoBruto: '',
    numero: ''
  }
})

export default withRedux(withReduxForm(PesadoBrutoBalancero))
